import { render, staticRenderFns } from "./AttachedPo.vue?vue&type=template&id=f0224072&scoped=true&"
import script from "./AttachedPo.vue?vue&type=script&lang=js&"
export * from "./AttachedPo.vue?vue&type=script&lang=js&"
import style0 from "./AttachedPo.vue?vue&type=style&index=0&id=f0224072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0224072",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0224072')) {
      api.createRecord('f0224072', component.options)
    } else {
      api.reload('f0224072', component.options)
    }
    module.hot.accept("./AttachedPo.vue?vue&type=template&id=f0224072&scoped=true&", function () {
      api.rerender('f0224072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/AttachedPo.vue"
export default component.exports